export default function log({ next, to }) {
  document.title = `${to.meta.title ? to.meta.title : to.name} - ${
    process.env.VUE_APP_TITLE
  }`;

  return next();
}
